var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 175,
    viewBox: "0 0 254 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_785_2680)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.028 151.242C206.558 167.151 135.242 177.333 74.2651 169.932C13.2884 162.53 -14.057 134.188 15.506 119.204C45.0691 104.22 201.499 135.332 204.028 151.242Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    width: 192,
    height: 236,
    rx: 8,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.051,
    y: 20.6719,
    width: 31.0468,
    height: 30.7202,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.41 36.4045C238.255 36.4045 241.373 33.6823 241.373 30.3243C241.373 26.9663 238.255 24.2441 234.41 24.2441C230.564 24.2441 227.446 26.9663 227.446 30.3243C227.446 33.6823 230.564 36.4045 234.41 36.4045Z",
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.319,
    y: 40.2959,
    width: 24.5106,
    height: 2.43208,
    rx: 1.21604,
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.775,
    y: 44.6738,
    width: 16.7118,
    height: 2.43208,
    rx: 1.21604,
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 8C62 3.58172 65.5817 0 70 0H246C250.418 0 254 3.58172 254 8V13H62V8Z",
    fill: "#5960AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 9C77.1046 9 78 8.10457 78 7C78 5.89543 77.1046 5 76 5C74.8954 5 74 5.89543 74 7C74 8.10457 74.8954 9 76 9Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 9C89.1046 9 90 8.10457 90 7C90 5.89543 89.1046 5 88 5C86.8954 5 86 5.89543 86 7C86 8.10457 86.8954 9 88 9Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 9C101.105 9 102 8.10457 102 7C102 5.89543 101.105 5 100 5C98.8954 5 98 5.89543 98 7C98 8.10457 98.8954 9 100 9Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 53.8398,
    width: 31,
    height: 84.7476,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 58.8398,
    width: 17,
    height: 14,
    rx: 4,
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 77.8398,
    width: 17,
    height: 14,
    rx: 4,
    fill: "#5960AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 96.8398,
    width: 17,
    height: 14,
    rx: 4,
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 115.84,
    width: 17,
    height: 14,
    rx: 4,
    fill: "#5960AC"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_785_2680)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.1401,
    y: 51,
    width: 136,
    height: 27,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 58,
    width: 23,
    height: 4.875,
    rx: 2.4375,
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 66.125,
    width: 15.4384,
    height: 4.875,
    rx: 2.4375,
    fill: "#636BC1"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.14 72C204.006 72 207.14 68.866 207.14 65C207.14 61.134 204.006 58 200.14 58C196.274 58 193.14 61.134 193.14 65C193.14 68.866 196.274 72 200.14 72Z",
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.14 68C201.797 68 203.14 66.6569 203.14 65C203.14 63.3431 201.797 62 200.14 62C198.483 62 197.14 63.3431 197.14 65C197.14 66.6569 198.483 68 200.14 68Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.1401,
    y: 20,
    width: 136,
    height: 27,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 27,
    width: 22,
    height: 4.875,
    rx: 2.4375,
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 35.125,
    width: 14.7671,
    height: 4.875,
    rx: 2.4375,
    fill: "#636BC1"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.14 41C204.006 41 207.14 37.866 207.14 34C207.14 30.134 204.006 27 200.14 27C196.274 27 193.14 30.134 193.14 34C193.14 37.866 196.274 41 200.14 41Z",
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.14 37C201.797 37 203.14 35.6569 203.14 34C203.14 32.3431 201.797 31 200.14 31C198.483 31 197.14 32.3431 197.14 34C197.14 35.6569 198.483 37 200.14 37Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.1401,
    y: 82,
    width: 136,
    height: 27,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.063,
    y: 89.5996,
    width: 35.1549,
    height: 4.72028,
    rx: 2.36014,
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.063,
    y: 96.6802,
    width: 23.6197,
    height: 4.72028,
    rx: 2.36014,
    fill: "#636BC1"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.14 102C204.006 102 207.14 98.866 207.14 95C207.14 91.134 204.006 88 200.14 88C196.274 88 193.14 91.134 193.14 95C193.14 98.866 196.274 102 200.14 102Z",
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.14 98C201.797 98 203.14 96.6569 203.14 95C203.14 93.3431 201.797 92 200.14 92C198.483 92 197.14 93.3431 197.14 95C197.14 96.6569 198.483 98 200.14 98Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.1401,
    y: 144,
    width: 136,
    height: 27,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 113,
    width: 136,
    height: 27,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_785_2680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.9229,
    y: 120.6,
    width: 35.1549,
    height: 4.72028,
    rx: 2.36014,
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.9229,
    y: 127.68,
    width: 23.6197,
    height: 4.72028,
    rx: 2.36014,
    fill: "#636BC1"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 134C203.866 134 207 130.866 207 127C207 123.134 203.866 120 200 120C196.134 120 193 123.134 193 127C193 130.866 196.134 134 200 134Z",
    fill: "#636BC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 130C201.657 130 203 128.657 203 127C203 125.343 201.657 124 200 124C198.343 124 197 125.343 197 127C197 128.657 198.343 130 200 130Z",
    fill: "#F2F2F2"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5513 39.2697L71.4841 33.2476C72.9158 31.1828 74.3472 29.5601 75.7784 28.3796C76.2222 28.1468 77.0102 27.975 76.3398 29.45C75.6694 30.9251 75.0254 32.5093 75.4261 32.9276C75.8269 33.3459 76.7394 32.674 77.228 33.3795C77.5537 33.8499 75.9805 34.7171 72.5085 35.9812L66.153 43.029L62.5513 39.2697Z",
    fill: "#FBC5A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7095 52.0572L36.8771 49.5335C47.4201 47.9349 57.7929 42.9923 67.9956 34.7056L74.9987 44.9077C61.4724 52.3029 48.4972 55.6194 36.7095 52.0572Z",
    fill: "#34396F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.105 40.919C40.612 42.2364 42.16 42.9946 42.944 42.8951C44.9098 42.6456 46.0324 35.133 44.9368 31.9432C43.8411 28.7533 36.4503 26.3377 35.3291 32.1696C34.94 34.1936 35.5014 36.1347 36.4827 37.7962L33.0552 48.0814L39.1407 48.9839L39.105 40.919Z",
    fill: "#FBC5A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.012 29.2623C45.8272 30.7319 44.6145 31.775 43.2682 31.6542C42.4715 31.7968 41.4655 31.8391 40.3662 31.7568C40.4177 32.204 40.4135 32.7029 40.3438 33.257C40.2823 33.7462 40.1673 34.2577 40.0094 34.771C39.8114 34.4312 39.5205 34.1855 39.1999 34.1379C38.3029 34.0049 37.5778 34.713 37.4709 35.5632C37.3352 36.6422 37.8111 37.5079 38.6412 37.6946C37.6889 39.1545 36.4964 40.1834 35.4537 40.0288C33.4732 39.7351 32.4263 36.6529 32.8148 33.5636C32.8284 33.4551 32.844 33.3476 32.8613 33.2411C32.1281 33.641 31.4245 34.2032 30.7159 34.7696C29.2103 35.9729 27.6817 37.1945 25.7967 36.9149C22.0254 36.3556 21.5656 27.8791 26.8348 28.6605C30.4182 29.1919 32.1096 30.0203 33.5232 31.0839C33.9381 30.2118 34.4918 29.509 35.1182 29.0537C35.2732 28.9095 35.499 28.783 35.7831 28.6768C35.9578 28.6044 36.1358 28.5508 36.3161 28.5173C37.2782 28.2878 38.6375 28.2269 40.1268 28.3906C40.4049 28.4211 40.6771 28.4584 40.9418 28.5016C41.1368 26.9866 42.4247 25.9275 43.8224 26.1348C45.2228 26.3425 46.2031 27.7427 46.012 29.2623Z",
    fill: "#5B1E13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7578 80.4336L42.1323 115.487L46.5416 141.805H50.9672L46.5495 80.4336H32.7578Z",
    fill: "#FBC5A9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5446 80.4336C29.1988 98.6435 28.9408 108.576 28.7944 110.23C28.648 111.885 27.8169 122.965 22.1533 142.361H26.7563C34.2568 123.754 36.8751 112.673 37.7353 110.23C38.5956 107.787 41.1363 97.8547 44.8456 80.4336H28.5446Z",
    fill: "#FBC5A9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5562 80.4336C34.9946 92.4955 39.2121 111.749 45.2086 138.195H51.6816C52.1597 111.051 50.1259 93.1857 46.6038 80.4336H32.5562Z",
    fill: "#5960AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.512 80.4336C29.1526 98.6435 27.4924 116.584 22.3496 138.479H29.2559C36.7701 120.15 42.1558 102.298 45.8366 80.4336H28.512Z",
    fill: "#636BC1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4971 145.971L21.6776 142.813C21.7148 142.162 22.3659 141.707 23.018 141.736C25.0659 141.827 27.3386 140.972 27.3386 140.972C29.7465 142.823 32.9859 143.891 35.0312 144.424C36.0751 144.696 36.7546 145.76 36.4819 146.804H27.3386H22.005L21.4971 145.971Z",
    fill: "#191847"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5537 145.971L45.7342 142.813C45.7715 142.162 46.4225 141.707 47.0746 141.736C49.1225 141.827 51.3952 140.972 51.3952 140.972C53.8031 142.823 57.0426 143.891 59.0879 144.424C60.1317 144.696 60.8112 145.76 60.5385 146.804H51.3952H46.0617L45.5537 145.971Z",
    fill: "#191847"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1094 74.5151C20.1094 74.5151 17.4582 91.2303 16.6796 92.9453C16.299 93.7838 13.4821 96.331 11.5274 97.7864C10.7428 98.3705 11.0675 99.1181 11.3639 99.3166C13.7742 100.932 15.3612 99.022 17.4474 97.9681C19.733 96.8134 19.54 100.074 21.3519 99.1934C20.7956 97.8395 19.4947 95.32 20.1094 93.6658C20.5192 92.5629 25.6612 74.5388 25.6612 74.5388L20.1094 74.5151Z",
    fill: "#FBC5A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8721 80.5673H46.3286C46.3286 80.5673 39.2196 61.7985 39.2196 48.6795L33.0489 47.6812C28.1993 56.1503 26.8298 66.5776 25.8721 80.5673Z",
    fill: "#DDE3E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5737 90.087C18.8109 62.6807 32.9135 47.6812 32.9135 47.6812L32.9184 47.6859C32.9192 47.6843 32.92 47.6827 32.9208 47.6812H33.3236C34.0466 47.7082 35.526 47.7786 35.526 47.7786L37.017 52.4055C37.2536 60.8674 39.7803 86.5116 39.7803 86.5116H26.3902C26.413 87.6875 26.4634 88.8798 26.5445 90.087H16.5737Z",
    fill: "#34396F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3926 86.6252C26.2857 81.5048 26.704 76.697 27.4019 72.3462C27.7669 77.5089 28.5297 83.7212 30.123 86.6252H26.3926Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3555 77.6826L35.9677 74.3447V77.6826H29.3555Z",
    fill: "white",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.974,
    height: 57.8488,
    fill: "white",
    transform: "matrix(1 0 -0.0274791 0.999622 3.64307 117.173)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    width: 192,
    height: 145.813,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.6553,
    height: 100.337,
    fill: "white",
    transform: "translate(216.417 53.8398)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 75,
    fill: "white",
    transform: "translate(225 58.8398)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 151,
    fill: "white",
    transform: "translate(78 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 27,
    fill: "white",
    transform: "translate(78 51)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 13,
    fill: "white",
    transform: "translate(87 58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 27,
    fill: "white",
    transform: "translate(78 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 13,
    fill: "white",
    transform: "translate(87 27)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 27,
    fill: "white",
    transform: "translate(78 82)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 12.2727,
    fill: "white",
    transform: "translate(87.1401 89.3638)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 27,
    fill: "white",
    transform: "translate(78 144)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 27,
    fill: "white",
    transform: "translate(78 113)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_785_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 12.2727,
    fill: "white",
    transform: "translate(87 120.364)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5ca4c3d36b91387a9dbcd376c1ed0dde.svg";
export { ForwardRef as ReactComponent };